import { css } from '@emotion/core'
import { colors, spacing, font, measures } from 'styles/variables'
import * as MQ from 'styles/media-queries'

const { unit } = measures

export const menuWrapper = css`
  background-color: ${colors.grays.gray8};
  border-right: 1px solid ${colors.grays.gray7};
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: auto;
  width: ${spacing(43.75)};
  z-index: 3;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  ${(MQ.PHONES, MQ.TABLETS)} {
    display: none;
    top: ${spacing(10)};
  }
`
export const heading = css`
  padding: ${spacing(3, 5)};
  display: block;
  & img {
    display: block;
  }
  ${(MQ.PHONES, MQ.TABLETS)} {
    display: none;
  }
`
export const mobileMenuBalance = css`
  ${MQ.NOT_PHONES} {
    display: none;
  }

  ${MQ.PHONES} {
    margin: ${spacing(2, 4)};
  }
`
export const menuList = css`
  ${MQ.NOT_PHONES} {
    margin-top: ${spacing(6)};
  }
  ${MQ.PHONES} {
    margin-top: ${spacing(2)};
  }
  & li {
    list-style: none;
  }
`

export const linkBack = css`
  display: flex;

  align-items: center;
  height: ${spacing(5)};

  white-space: nowrap;
  text-decoration: none;
  color: ${colors.white100};

  > span {
    width: ${spacing(0.75)};
    margin-right: ${unit * 4}px;
    height: 100%;
  }

  & > div > span {
    font-weight: ${font.weight.medium};
  }

  :hover {
    color: ${colors.greens.green6};
    & > div > span {
      color: ${colors.greens.green6};
    }
  }
`
export const branding = css`
  font-family: ${font.family};
  font-size: ${spacing(2)};
  font-style: normal;
  font-weight: ${font.weight.medium};
  color: rgba(255, 255, 255, 0.6);
`
export const menuTitle = css`
  font-family: ${font.family};
  font-size: ${spacing(1.5)};
  font-style: normal;
  font-weight: ${font.weight.semiBold};
  color: rgba(255, 255, 255, 0.6);
`

export const copyright = css`
  font-family: ${font.family};
  font-size: ${spacing(1.5)};
  font-style: normal;
  font-weight: ${font.weight.medium};
  color: rgba(255, 255, 255, 0.6);
  text-align: center;
  margin-bottom: 10px;
`
